// AUTO-GENERATED by shared/generators/entity_urls_generator.py — do not edit by hand.
// Source: shared/config/modules_entities.config.json

import { ENTITY_URL_REGISTRY } from './registry';

/**
 * Fill `{id}` and any other `{name}` placeholders in a template with values.
 * Returns null if any required placeholder is missing from `values`.
 */
export function fillTemplate(
  template: string,
  values: Record<string, string | undefined>,
): string | null {
  const result = template.replace(/\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (_, key) => {
    const v = values[key];
    if (v === undefined || v === null) {
      return '\u0000'; // sentinel for missing
    }
    return encodeURIComponent(v);
  });
  return result.includes('\u0000') ? null : result;
}

/**
 * Resolve a URL for an entity type using the generated registry.
 * Prefers urlContextTemplate when all its placeholders are filled by `values`.
 * Falls back to urlTemplate otherwise. Returns null if no entry or template
 * can be filled.
 *
 * A CONTEXT-ONLY entry (no `urlTemplate` — a child edited on a tab of its
 * parent's page) has nothing to fall back to, so a caller who does not supply
 * the contextual template's extra placeholders gets null. That is deliberate: a
 * path missing its parent id would land the user on someone else's record.
 */
export function resolveEntityUrl(
  entityType: string,
  values: Record<string, string | undefined>,
): string | null {
  const entry = ENTITY_URL_REGISTRY[entityType];
  if (!entry) return null;
  if (entry.urlContextTemplate) {
    const ctxUrl = fillTemplate(entry.urlContextTemplate, values);
    if (ctxUrl) return ctxUrl;
  }
  return entry.urlTemplate ? fillTemplate(entry.urlTemplate, values) : null;
}
